import {consola as l} from "consola/basic";
import {backOff} from '../backoff';

function check() {

    backOff(() => {

        let state = window.sessionStorage.getItem('cmp-consent-state');

        if (state != null && parseInt(state) !== -1) {
            let a, c = document.createElement("script"), f = window.frameElement;
            c.id = "CleverCoreLoader74138";
            c.src = "https://scripts.cleverwebserver.com/47178afddbce1c1e20de3d7eb6d79c80.js";
            c.async = !0;
            c.type = "text/javascript";
            c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));


            /*
            *
            c.setAttribute("data-callback", "document.body.classList.add('clever');");
            c.setAttribute("data-callback-url-click", "document.body.classList.add('clever-click');");
            c.setAttribute("data-callback-url-view", "document.body.classList.add('clever-view');");
            */

            c.addEventListener('load', function () {
                window.cleverLibraryLoad = true;
                l.info('Clever adv loaded')
            });

            try {
                a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
            } catch (e) {
                a = !1;
            }
            a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
            a.parentNode.insertBefore(c, a);

            return;
        }

        throw new Error("Clever adv NOT loaded, try again...");

    }, {
        maxDelay: 30_000,
        numOfAttempts: 10,
        startingDelay: 1000,
    }).catch(e => {
        l.error(e);
    });
}


check();